import { Link } from 'react-router-dom';
import { categories, allArticles } from '@/mocks/articles';

export default function GalleryPreview() {
  const galleryCat = categories.find((c) => c.slug === 'common-poisonous');
  const slugs = (galleryCat?.articles || []).slice(0, 4);
  const articles = slugs.map((slug) => allArticles.find((a) => a.slug === slug)).filter(Boolean);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1 rounded-full mb-4">
            警惕
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            常见毒蘑菇图鉴
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            了解中国最常见的毒蘑菇种类，通过高清图鉴对比提高识别能力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {articles.map((article, index) => {
            const imgSources = [
              'https://readdy.ai/api/search-image?query=A%20pure%20white%20wild%20mushroom%20with%20a%20smooth%20cap%20growing%20on%20forest%20floor%20with%20green%20moss%2C%20natural%20lighting%2C%20clean%20background%2C%20detailed%20botanical%20photography%2C%20soft%20warm%20earthy%20tones&width=600&height=450&seq=mush-card-01&orientation=landscape',
              'https://readdy.ai/api/search-image?query=A%20wild%20mushroom%20with%20olive%20green%20cap%20and%20white%20stem%20in%20a%20woodland%20setting%2C%20fallen%20leaves%20around%2C%20natural%20forest%20light%2C%20detailed%20closeup%20nature%20photography%2C%20warm%20earthy%20color%20palette&width=600&height=450&seq=mush-card-02&orientation=landscape',
              'https://readdy.ai/api/search-image?query=Small%20brown%20wild%20mushrooms%20growing%20on%20decaying%20wood%20in%20a%20forest%2C%20soft%20natural%20light%2C%20moss%20covered%20log%2C%20detailed%20macro%20nature%20photography%2C%20warm%20amber%20and%20brown%20tones&width=600&height=450&seq=mush-card-03&orientation=landscape',
              'https://readdy.ai/api/search-image?query=A%20large%20white%20mushroom%20with%20brown%20scales%20on%20the%20cap%20standing%20in%20a%20grassy%20meadow%2C%20soft%20afternoon%20light%2C%20shallow%20depth%20of%20field%2C%20clean%20natural%20background%2C%20warm%20earthy%20aesthetic&width=600&height=450&seq=mush-card-04&orientation=landscape',
            ];
            return (
              <Link
                key={article?.slug || index}
                to={`/article/${article?.slug}`}
                className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={imgSources[index]}
                    alt={article?.title || ''}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-1.5 mb-2">
                    <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                    <span className="text-xs text-accent-600 font-medium">有毒</span>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article?.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {article?.excerpt}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/common-poisonous"
            className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 font-medium text-sm transition-colors"
          >
            查看全部毒蘑菇图鉴
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}